import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getDairyFeedAdditives } from "services";

import { DEFAULT_CACHE_TIME, GET_DAIRY_FEED_ADDITIVES } from "consts";

import { DairyFeedAdditive, WithInjectedName } from "models";

export const useGetDairyFeedAdditives = () => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("dairy", { useSuspense: false });

  return useQuery<Array<WithInjectedName<DairyFeedAdditive>>>({
    queryKey: [GET_DAIRY_FEED_ADDITIVES],
    queryFn: async () => {
      const feedAdditives = await getDairyFeedAdditives();
      return feedAdditives.map((fa) => ({ ...fa, name: t(`feedAdditives.${fa.translationSlug}`) }));
    },
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
